import { ACTION } from "src/util/utils";
import {
  LocationList_IMPORT_FILE,
  LocationList_IMPORT_FILE_FAILED,
  LocationList_IMPORT_FILE_SUCCESS,
  KEYS,
  MODULE_KEY,
  LocationList_CLEAN_IMPORT_LAYOUT,
} from "./actions";

export const REDUCER_KEY = KEYS[MODULE_KEY + ACTION.STATE_KEY];

export interface ILocationListUpdateState {
  loading: boolean;
  error: any;
  data: [];
  importLoading: boolean;
  importValidationData: any[];
}

const defaultState: ILocationListUpdateState = {
  loading: false,
  error: null,
  data: [],
  importLoading: false,
  importValidationData: []
};

export const locationListUpdateReducer = (
  state = defaultState,
  { type, payload }: any
) => {
  switch (type) {
    case KEYS[MODULE_KEY + ACTION.FETCH]:
      return {
        ...state,
        loading: true,
      };

    case KEYS[MODULE_KEY + ACTION.SUCCESS]:
      return {
        ...state,
        loading: false,
        data: [...payload],
      };
    case KEYS[MODULE_KEY + ACTION.FAILED]:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case LocationList_IMPORT_FILE: {
      return {
        ...state,
        importLoading: true,
      };
    }
    case LocationList_IMPORT_FILE_SUCCESS: {
      return {
        ...state,
        importLoading: false,
        importValidationData: payload,
      };
    }
    case LocationList_IMPORT_FILE_FAILED: {
      return {
        ...state,
        importLoading: false,
        importValidationData: payload,
      };
    }
    case LocationList_CLEAN_IMPORT_LAYOUT: {
      return {
        ...state,
        importLoading: false,
        importFailed: false,
        importValidationData: [],
      };
    }
    default:
      return state;
  }
};
